import { SubscriptionType, SubscriptionTypeList } from "../../../utils/const";
import { format, set } from "date-fns";
import { Spinner, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import './MachineSubscriptionsGrid.scss'
import { Machine } from "../../../utils/models/Machine";
import { randInt } from "three/src/math/MathUtils";
import { createColumnHelper } from "@tanstack/react-table";
import { Instalation } from "../../../utils/models/Instalation";
import { useEffect, useState } from "react";
import { getCompanyInstalations } from "../../../utils/services/company.service";
import { useSelector } from "react-redux";
import { selectUser } from "../../../utils/redux/userSlice";
import { DataGrid } from "aw-data-grid";

const MachineSubscriptionGrid = (props: { loading: boolean, machines: Machine[], onClickActivate: (m: Machine) => void, onClickCancel: (m: Machine) => void, iduser: number }) => {
    const user = useSelector(selectUser)
    const { t } = useTranslation();
    const [instalations, setInstalations] = useState<Instalation[]>([])
    const [machines, setMachines] = useState<Machine[]>([]);
    const columnHelper = createColumnHelper<Machine>()
    const [loadingData, setLoadingData] = useState(true)
    const subscriptionTypeList = SubscriptionTypeList()
    const columns = [
        columnHelper.accessor("name", {
            header: t("Name"),
            enableSorting: true,
            cell: (info) => info.getValue()
        }),
        columnHelper.accessor("instalation.name", {
            id: "instalation",
            header: t("Installation"),
            enableSorting: true,
            enableColumnFilter: true,
            meta: {
                filterOptions: Array.from(
                    new Set(instalations.map((i) => i.name))
                ).map((name) => ({ label: name, value: name }))
            },
            cell: (info) =>
                info.getValue()


        }),
        columnHelper.accessor("serial_number", {
            header: t("NSerie"),
            enableSorting: false,
            enableColumnFilter: false,
            cell: (info) => info.getValue()
        }),
        columnHelper.accessor("licenseState", {
            header: t("State"),
            enableColumnFilter: true,
            enableSorting: true,
            meta: {
                filterOptions: subscriptionTypeList.map((s) => ({
                    label: s.label,
                    value: s.value,
                })),
            },

            cell: (info) => t(SubscriptionType[info.getValue()])
        }),
        columnHelper.accessor("expDate", {
            header: t("ExpirationDate"),
            enableSorting: true,
            enableColumnFilter: false,
            cell: (info) => {
                const rawValue = info.getValue();

                if (!rawValue) return "";

                let date: Date;

                if (rawValue instanceof Date) {
                    date = rawValue;
                } else {
                    date = new Date(rawValue);
                }

                if ([SubscriptionType.Inactive, SubscriptionType.Canceled].includes(info.row.original.licenseState)) {
                    return ""
                }

                return format(date, "dd/MM/yyyy");
            }
        }
        ),
        columnHelper.display({
            id: "actions",
            header: "",
            cell: (info) => (
                <div className='text-center'>
                    {[SubscriptionType.Active, SubscriptionType.Trial].includes(info.row.original.licenseState) ?
                        <span onClick={() => props.onClickCancel(info.row.original)} className="btn-Cancel">{t('Cancel')}</span>
                        :
                        <button onClick={() => props.onClickActivate(info.row.original)} className='w-100 btn-Custom btn-IDGreen'>{t('Activate')}</button>}
                </div>
            ),
            enableSorting: false,
            enableColumnFilter: false
        })

    ]

    useEffect(() => {
        setMachines(props.machines);
    }, [props.machines]);


    return (
        <div className={`p-2 pb-0 rounded-3 editGridMachineSubs`}>
            {props.loading ? <div className="text-center pt-5"><Spinner animation="border" variant="success" /></div> : (props.machines.length > 0) ? <div className={`table-responsive editScrollMachineSubs`}>
                <DataGrid

                    data={machines}
                    columns={columns}
                    manual={false}
                    // sorting={sorting}
                    // onSortingChange={setSorting}
                    // globalFilter={globalSearch}
                    // onGlobalFilterChange={setGlobalSearch}
                    // columnFilters={filtres} 
                    // onColumnFiltersChange={setFilters} 
                    filtersPlaceholder={t('Search')}
                />
            </div> : <p className='text-center'>{t('NoMachines')}</p>}
        </div >
    )

}
export default MachineSubscriptionGrid;